export const Tick = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5917 6.50834C15.5142 6.43023 15.4221 6.36824 15.3205 6.32593C15.219 6.28362 15.11 6.26184 15 6.26184C14.89 6.26184 14.7811 6.28362 14.6796 6.32593C14.578 6.36824 14.4858 6.43023 14.4084 6.50834L8.20004 12.725L5.59171 10.1083C5.51127 10.0306 5.41632 9.96955 5.31227 9.92854C5.20823 9.88754 5.09713 9.86743 4.98531 9.86936C4.87349 9.8713 4.76315 9.89524 4.66058 9.93982C4.55802 9.98439 4.46524 10.0487 4.38754 10.1292C4.30984 10.2096 4.24875 10.3046 4.20774 10.4086C4.16674 10.5127 4.14663 10.6238 4.14856 10.7356C4.1505 10.8474 4.17444 10.9577 4.21902 11.0603C4.2636 11.1629 4.32794 11.2556 4.40837 11.3333L7.60837 14.5333C7.68584 14.6114 7.77801 14.6734 7.87956 14.7157C7.98111 14.7581 8.09003 14.7798 8.20004 14.7798C8.31005 14.7798 8.41897 14.7581 8.52052 14.7157C8.62207 14.6734 8.71424 14.6114 8.79171 14.5333L15.5917 7.73334C15.6763 7.6553 15.7438 7.56059 15.79 7.45518C15.8361 7.34976 15.86 7.23592 15.86 7.12084C15.86 7.00575 15.8361 6.89192 15.79 6.7865C15.7438 6.68108 15.6763 6.58637 15.5917 6.50834Z"
        fill="currentColor"
      />
    </svg>
  );
};
